module.exports = __webpack_public_path__ + "img/stock5.9227447b.png";